// Modal mínimo — abrir/fechar com ESC, click no backdrop fecha.
let _backdrop = null;

export function openModal({ title, body, footer, wide = false, onClose }) {
  closeModal();
  _backdrop = document.createElement('div');
  _backdrop.className = 'lex-modal-backdrop';
  _backdrop.innerHTML = `
    <div class="lex-modal ${wide ? 'lex-modal--wide' : ''}" role="dialog" aria-modal="true">
      <div class="lex-modal-head">
        <h3>${title || ''}</h3>
        <button class="x" aria-label="Fechar">×</button>
      </div>
      <div class="lex-modal-body"></div>
      <div class="lex-modal-foot"></div>
    </div>
  `;
  document.body.appendChild(_backdrop);

  const bodyEl = _backdrop.querySelector('.lex-modal-body');
  const footEl = _backdrop.querySelector('.lex-modal-foot');

  if (typeof body === 'string') bodyEl.innerHTML = body;
  else if (body instanceof Node) bodyEl.appendChild(body);

  if (footer) {
    if (typeof footer === 'string') footEl.innerHTML = footer;
    else footEl.appendChild(footer);
  } else {
    footEl.style.display = 'none';
  }

  const close = () => {
    closeModal();
    if (typeof onClose === 'function') onClose();
  };
  _backdrop.querySelector('.x').addEventListener('click', close);
  _backdrop.addEventListener('click', (e) => {
    if (e.target === _backdrop) close();
  });
  document.addEventListener('keydown', escClose);

  function escClose(e) {
    if (e.key === 'Escape') {
      document.removeEventListener('keydown', escClose);
      close();
    }
  }

  return { backdrop: _backdrop, body: bodyEl, foot: footEl, close };
}

export function closeModal() {
  if (_backdrop && _backdrop.parentNode) _backdrop.parentNode.removeChild(_backdrop);
  _backdrop = null;
}
